<template>
    <div class="page-wrapper page">
        <div class="page-grid-wrapper standardPage">
            <div class="page-grid-fix">
                <article class="grid-container columns-one tick">
                    <section class="section1">
                        <div class="login-register">
                            <p>Not a member?
                                <router-link to="/register">Register here</router-link>
                            </p>
                        </div>
                        <h1>Login</h1> 
                    </section>
                    <section class="section2">
                        <div class="form-enquiry" id="login">
                           <LoginForm/>
                        </div>
                    </section>
                </article>      
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .login .standardPage article.columns-one {
        grid-template-areas:
            'section1' 
            'section2';
        grid-template-columns: 1fr;
        row-gap: 85px;
    }
    .section1 {
        height: auto;
        display: flex;
        align-items: center;
    }
</style>
<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import LoginForm from "../components/LoginForm.vue"
import axios from 'axios'

const emit = defineEmits(['route-data-ready']) // declare emits

const route = useRoute()
const content = ref({})
const activeItem = ref('login')
const showRoute = ref(route.name)

const getContent = async (address = "/api/membership") => {
  const response = await axios.get(address)
  content.value = response.data.data[0]
  emit("route-data-ready") // use emit, not this.$emit
}

onMounted(() => {
  getContent()
})

watch(() => route.name, (newRoute) => {
  showRoute.value = newRoute
})
</script>
